import { createSlice } from "@reduxjs/toolkit";


const uiSlice = createSlice({
    name: 'Ui',
    initialState: {
        isNestedDropdownOpen: false,
    },
    reducers: {
        setIsNestedDropdownOpen(state, action) {
            state.isNestedDropdownOpen = action.payload

        }
    }
})

export const uiActions = uiSlice.actions;

export default uiSlice;


